import { fetchEmailInputValidation } from "../../validation/api"

export async function validateCurrentEmail(value: string, abortSignal: AbortSignal): Promise<string | undefined> {
    return (await fetchEmailInputValidation(value, false, abortSignal)).errorMessage
}
